import { render, staticRenderFns } from "./cooperateOrganizationDetail.vue?vue&type=template&id=a4699aae&scoped=true"
import script from "./cooperateOrganizationDetail.vue?vue&type=script&lang=js"
export * from "./cooperateOrganizationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4699aae",
  null
  
)

export default component.exports